const initialState = { me: {} }

export default (state = initialState) => {
  // TODO
  return state
}
